module.exports = __webpack_public_path__ + "img/rbb.a2fc48fe.jpg";